const STAGES = ["New", "Aware", "Discovery", "Demo", "Negotiation", "Closed"];

const STAGE_ALIAS_MAP = {
    new: "new",
    aware: "aware",
    discovery: "discovery",
    demo: "demo",
    negotiation: "negotiation",
    closed: "closed",
    won: "closed",
    lost: "closed",
};

function normalizeStage(value) {
    const normalized = String(value || "").trim().toLowerCase().replace(/[_-]+/g, " ");
    if (!normalized) {
        return "";
    }

    if (STAGE_ALIAS_MAP[normalized]) {
        return STAGE_ALIAS_MAP[normalized];
    }

    if (normalized.includes("negotiation")) {
        return "negotiation";
    }

    if (normalized.includes("discovery")) {
        return "discovery";
    }

    if (normalized.includes("aware")) {
        return "aware";
    }

    if (normalized.includes("demo")) {
        return "demo";
    }

    if (normalized.includes("new")) {
        return "new";
    }

    if (normalized.includes("closed") || normalized.includes("won") || normalized.includes("lost")) {
        return "closed";
    }

    return "";
}

function getDealStage(deal) {
    return normalizeStage(
        deal?.stage ||
        deal?.deal_stage ||
        deal?.dealStage ||
        deal?.stages ||
        deal?.status
    );
}

function isPrimaryDeal(deal) {
    return Boolean(
        deal?.is_primary ||
        deal?.primary ||
        deal?.isPrimary ||
        deal?.primary_deal ||
        deal?.primaryDeal
    );
}

function getDealActivityTimestamp(deal) {
    const candidate =
        deal?.last_activity_at ||
        deal?.last_touch ||
        deal?.updated_at ||
        deal?.modified_at ||
        deal?.created_at;
    const parsed = Date.parse(String(candidate || ""));
    return Number.isFinite(parsed) ? parsed : 0;
}

function toStageLabel(stageKey) {
    return STAGES.find((label) => normalizeStage(label) === stageKey) || "New";
}

function deriveContactStageModel({ stage, deals }) {
    const dealsList = Array.isArray(deals) ? deals : [];
    const dealEntries = dealsList
        .map((deal) => ({
            deal,
            stage: getDealStage(deal),
            activityTs: getDealActivityTimestamp(deal),
        }))
        .filter((entry) => Boolean(entry.stage));

    const explicitPrimaryDeal = dealEntries.find((entry) => isPrimaryDeal(entry.deal));
    const mostRecentDeal = [...dealEntries].sort((a, b) => b.activityTs - a.activityTs)[0] || null;
    const primaryDealEntry = explicitPrimaryDeal || mostRecentDeal;

    const occupiedStageSet = new Set(dealEntries.map((entry) => entry.stage));
    const normalizedContactStage = normalizeStage(stage);
    const effectiveStage = primaryDealEntry?.stage || (dealsList.length > 0 ? "discovery" : (normalizedContactStage || "new"));

    if (dealsList.length > 0 && !primaryDealEntry?.stage) {
        occupiedStageSet.add("discovery");
    }

    return {
        effectiveStage,
        effectiveLabel: toStageLabel(effectiveStage),
        occupiedStages: Array.from(occupiedStageSet),
        normalizedContactStage,
        hasDeals: dealsList.length > 0,
        primaryDeal: primaryDealEntry?.deal || null,
    };
}

export {
    STAGES,
    normalizeStage,
    deriveContactStageModel,
};